import { theme } from '../../../../core/theme/theme';

export const ModalStyles = (isOpen: boolean) => {
    return {
        Modal: {
            display: isOpen ? 'block' : 'none',
            position: 'absolute',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            width: 'auto',
            height: 'auto',
            padding: 10,
            borderRadius: 5,
            backgroundColor: theme.colors.default,
            transform: 'translate(-50%, -50%)',
            zIndex: 10000,
            fontFamily: 'Kohinoor',
        } as const,
    };
};
